export default __webpack_public_path__ + "static/media/seizure_predictions.bfa8e69f.png";